const $inject = ['$scope', '$routeParams', 'settingsService', 'dataService'];

const lbaRadioCtrl = function ($scope, $routeParams, settingsService, dataService) {
    const vm = this;
    const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

    // Initialize timeframes object
    vm.timeframes = {};

    // Define your custom defaults (in days)
    const defaultTimeframeMap = {
        CostCentre: null,
        Department: null,
        Debtor: null
    };

    // Explicitly remove the old TicketCreditLevelTimeFrame property if it exists
    const oldTimeFrameLookup = dataService.spiltDataAt(vm.settings.dataAt + 'TimeFrame', $routeParams);
    _.set(dataService.data.activeItem, oldTimeFrameLookup, undefined);

    // Set default timeframes for all levels
    if (vm.settings.options && vm.settings.timeframeConfig) {
        vm.settings.options.forEach(option => {
            if (
              option.value !== 'Traveller' &&
              vm.settings.timeframeConfig[option.value]
            ) {
                vm.timeframes[option.value] = null;
            }
        });
    }

    // Read/write the main selection
    vm.data = _.get(dataService.data.activeItem, dataLookUp);
    if (vm.settings.defaultValue != null && (vm.data === undefined || vm.data === null)) {
        vm.data = vm.settings.defaultValue;
        _.set(dataService.data.activeItem, dataLookUp, vm.data);
    }

    // Load previously saved timeframes for all levels
    if (vm.settings.timeframeConfig) {
        ['CostCentre', 'Department', 'Debtor'].forEach(level => {
            if (vm.settings.timeframeConfig[level]) {
                const tfLookup = dataService.spiltDataAt(
                  vm.settings.dataAt + level + 'TimeFrame',
                  $routeParams
                );
                let saved = _.get(dataService.data.activeItem, tfLookup);

                // Convert number to string if needed
                if (saved !== undefined && saved !== null) {
                    saved = saved.toString();
                    vm.timeframes[level] = saved;
                }
            }
        });
    }

    vm.options = vm.settings.options || settingsService.options[vm.settings.optionsAt];

    // Helper function to determine if a dropdown should be enabled
    vm.isDropdownEnabled = function(optionValue) {
        if (vm.data === 'Traveller' || !vm.data) {
            return false;
        }
        
        // Define the hierarchy order
        const hierarchy = ['CostCentre', 'Department', 'Debtor'];
        const selectedIndex = hierarchy.indexOf(vm.data);
        const optionIndex = hierarchy.indexOf(optionValue);
        
        // Enable dropdown if the option is at the selected level or below
        const isEnabled = selectedIndex !== -1 && optionIndex <= selectedIndex;
        
        // Reset value to null if dropdown is disabled
        if (!isEnabled && vm.timeframes[optionValue] !== null) {
            vm.timeframes[optionValue] = null;
            const tfLookup = dataService.spiltDataAt(
                vm.settings.dataAt + optionValue + 'TimeFrame',
                $routeParams
            );
            _.set(dataService.data.activeItem, tfLookup, null);
        }
        
        return isEnabled;
    };

    // Persist radio changes
    $scope.$watchCollection('vm.data', (newVal, oldVal) => {
        if (newVal !== oldVal) {
            _.set(dataService.data.activeItem, dataLookUp, newVal);

            // Always ensure the old TimeFrame property is not set
            const oldTimeFrameLookup = dataService.spiltDataAt(vm.settings.dataAt + 'TimeFrame', $routeParams);
            _.set(dataService.data.activeItem, oldTimeFrameLookup, undefined);

            // Reset timeframes for disabled dropdowns
            ['CostCentre', 'Department', 'Debtor'].forEach(level => {
                if (!vm.isDropdownEnabled(level)) {
                    const tfLookup = dataService.spiltDataAt(
                        vm.settings.dataAt + level + 'TimeFrame',
                        $routeParams
                    );
                    vm.timeframes[level] = null;
                    _.set(dataService.data.activeItem, tfLookup, null);
                }
            });
        }
    });

    // Persist dropdown changes for all levels
    $scope.$watch('vm.timeframes', (newTf, oldTf) => {
        if (newTf !== oldTf && vm.data && vm.data !== 'Traveller') {
            // Always ensure the old TimeFrame property is not set
            const oldTimeFrameLookup = dataService.spiltDataAt(vm.settings.dataAt + 'TimeFrame', $routeParams);
            _.set(dataService.data.activeItem, oldTimeFrameLookup, undefined);

            // Save timeframes for all levels
            ['CostCentre', 'Department', 'Debtor'].forEach(level => {
                if (vm.settings.timeframeConfig && vm.settings.timeframeConfig[level]) {
                    const tfLookup = dataService.spiltDataAt(
                      vm.settings.dataAt + level + 'TimeFrame',
                      $routeParams
                    );
                    _.set(
                      dataService.data.activeItem,
                      tfLookup,
                      newTf[level]
                    );
                }
            });
        }
    }, true);
};

lbaRadioCtrl.$inject = $inject;
export default lbaRadioCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaRadio/lbaRadioCtrl.js